import React from 'react';
import {
  Facebook, Instagram, YouTube, Link as LinkIcon, LinkedIn, X as XIcon,
} from '@mui/icons-material';
import { SvgIconProps } from '@mui/material';
import { useDarkMode } from 'lib/hooks/useDarkMode';
import { TikTokIcon } from './TikTokIcon';
import { BehanceIcon } from './BehanceIcon';
import { TwitchIcon } from './TwitchIcon';
import { ThreadsIcon } from './ThreadsIcon';
import { SnapchatIcon } from './SnapchatIcon';

export const networkToColor = (network: number, isDarkMode?: boolean) => {
  if (network === 1) { // twitter
    return isDarkMode ? '#ffffff' : '#000000';
  } if (network === 2) { // 'instagram'
    return '#c32aa3';
  } if (network === 3) { // 'facebook'
    return '#3b5998';
  } if (network === 4) { // 'youtube'
    return '#ff0000';
  } if (network === 5) { // 'tiktok'
    return '#EE1D52';
  } if (network === 6) { // 'behance'
    return '#053eff';
  } if (network === 8) { // 'linkedin'
    return '#0077b5';
  } if (network === 9) { // 'twitch'
    return '#9146FF';
  } if (network === 10) { // 'threads'
    return isDarkMode ? '#ffffff' : '#000000';
  } if (network === 11) { // 'snapchat'
    return isDarkMode ? '#FFFC00' : '#000000';
  }
  return '#393939';
};

interface Props extends SvgIconProps {
  network: number;
  /** 
   * Icon color variant:
   * - 'color': Use the network's brand color
   * - 'monochrome': Use black in light mode, white in dark mode
   * - string: Use a custom color (e.g. '#ff0000' or 'red')
   */
  iconColor: 'color' | 'monochrome' | string;
}

export const NetworkIcon = ({
  network, iconColor, style, ...props
}: Props) => {
  const { isDarkMode } = useDarkMode();

  // Determine the color based on iconColor prop
  let color: string | undefined;
  const colorClass = '';

  if (iconColor === 'color') {
    // Use network brand color
    color = networkToColor(network, isDarkMode);
  } else if (iconColor === 'monochrome') {
    // Use black in light mode, white in dark mode
    color = isDarkMode ? '#ffffff' : '#000000';
  } else if (typeof iconColor === 'string') {
    // Use custom color
    color = iconColor;
  }

  const iconProps = {
    style: color ? { color, ...style } : style,
    className: colorClass,
    ...props,
  };

  if (network === 1) {
    return <XIcon {...iconProps} />;
  } if (network === 2) {
    return <Instagram {...iconProps} />;
  } if (network === 3) {
    return <Facebook {...iconProps} />;
  } if (network === 4) {
    return <YouTube {...iconProps} />;
  } if (network === 5) {
    return <TikTokIcon {...iconProps} />;
  } if (network === 6) {
    return <BehanceIcon {...iconProps} />;
  } if (network === 8) {
    return <LinkedIn {...iconProps} />;
  } if (network === 7) {
    return <LinkIcon {...iconProps} />;
  } if (network === 9) {
    return <TwitchIcon {...iconProps} />;
  } if (network === 10) {
    return <ThreadsIcon {...iconProps} />;
  } if (network === 11) {
    return <SnapchatIcon {...iconProps} />;
  }
  return (<div />);
};
